@if (!loading && assetLabel != null) {
  <div class="label-display">
    @if (assetLabelVersions.length > 1) {
      <mat-tab-group
        [selectedIndex]="activeAssetLabelTab"
        (selectedIndexChange)="onLabelTabChange($event)"
        >
        @for (tab of assetLabelVersions; track tab; let i = $index) {
          <mat-tab>
            <ng-template mat-tab-label>
              @if (i === 0 && !tab.pinnedVersion) {
                <span
                  >Latest (v{{ tab.versionNumber }})</span
                  >
                }
                @if (i !== 0) {
                  <span>v{{ tab.versionNumber }}</span>
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      }
      <table mat-table [dataSource]="assetLabelResultData">
        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef style="width: 150px">
            <b>Contents</b>
          </th>
          <td style="line-break: anywhere" mat-cell *matCellDef="let element">
            {{ element.key }}
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef style="text-align: right">
            <div style="display: inline-flex">
              <button
                mat-icon-button
                matTooltip="Edit Label"
                [disabled]="contentExtracting"
                (click)="openLabelEditor()"
                >
                <mat-icon color="primary">edit</mat-icon>
              </button>
              <button
                mat-icon-button
                matTooltip="Download Excel"
                [disabled]="contentExtracting"
                (click)="downloadExcel()"
                >
                <mat-icon
                  [color]="assetLabel.excelS3Uri ? 'success' : 'disabled'"
                  >download</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  matTooltip="Re-parse Label"
                  [disabled]="contentExtracting"
                  (click)="extractAssetContent()"
                  >
                  <mat-icon color="success">sync</mat-icon>
                </button>
              </div>
            </th>
            <td style="line-break: auto" mat-cell *matCellDef="let element">
              @if (
                element.key == 'additionalInfo' ||
                element.key == 'packaging' ||
                element.key == 'ingredients' ||
                element.key == 'nutritionFacts'
                ) {
                @for (info of element.value; track info) {
                  <div>
                    @if (info.key == 'nutrients' || info.key == 'items') {
                      <div style="display: flex; align-items: center">
                        <b>Table </b>
                        <mat-icon
                          style="cursor: pointer"
                          (click)="openTable(parseToTableProb(info.value))"
                          >table_view</mat-icon
                          >
                        </div>
                      }
                      @if (info.key != 'nutrients' && info.key != 'items') {
                        <b>{{ info.key }}:</b> {{ info.value }}
                      }
                    </div>
                  }
                }
                @if (
                  element.key == 'marketingCopy' || element.key == 'regulatoryInfo'
                  ) {
                  @for (content of element.value; track content) {
                    <div>
                      @for (info of content; track info) {
                        <div>
                          <b>{{ info.key }}:</b> {{ info.value }}
                        </div>
                      }
                    </div>
                  }
                }
                @if (
                  element.key != 'additionalInfo' &&
                  element.key != 'marketingCopy' &&
                  element.key != 'packaging' &&
                  element.key != 'regulatoryInfo' &&
                  element.key != 'ingredients' &&
                  element.key != 'nutritionFacts'
                  ) {
                  {{ element.value == null ? "null" : stringify(element.value) }}
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['key', 'value']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['key', 'value']"></tr>
          </table>
        </div>
      }

      @if (assetLabel == null && !loading) {
        <div
          class="label-display label-display--empty"
          >
          <div class="label-display__message">
            Asset Label has not been parsed
          </div>
          <button
            mat-raised-button
            color="buttonSuccess"
            [disabled]="contentExtracting"
            (click)="extractAssetContent()"
            >
            Parse Label
          </button>
        </div>
      }
